import React, { lazy } from 'react';
import { MapPinIcon, ClockIcon, PhoneIcon, ExternalLinkIcon } from 'lucide-react';
export function Locations() {
  const locationData = [{
    name: 'Annapolis Pharmacy',
    address: '2002 Jennifer Rd, Annapolis, MD 21401',
    phone: '(410) 555-0123',
    hours: [{
      days: 'Mon - Fri',
      time: '9:00 AM - 7:00 PM'
    }, {
      days: 'Sat',
      time: '10:00 AM - 4:00 PM'
    }, {
      days: 'Sun',
      time: 'Closed'
    }],
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3091.5645367355!2d-76.5444!3d38.9897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7f6562688997b%3A0x67397730e6686a9d!2s2002%20Jennifer%20Rd%2C%20Annapolis%2C%20MD%2021401!5e0!3m2!1sen!2sus!4v1715980000000!5m2!1sen!2sus'
  }, {
    name: 'Washington D.C. Pharmacy',
    address: '1234 Pennsylvania Ave NW, Washington, D.C. 20004',
    phone: '(202) 555-0199',
    hours: [{
      days: 'Mon - Fri',
      time: '8:30 AM - 6:30 PM'
    }, {
      days: 'Sat',
      time: '10:00 AM - 2:00 PM'
    }, {
      days: 'Sun',
      time: 'Closed'
    }],
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3105.150381926!2d-77.029!3d38.895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b7bcdecbb1df%3A0x715969d86d0b7105!2s1234%20Pennsylvania%20Ave%20NW%2C%20Washington%2C%20DC%2020004!5e0!3m2!1sen!2sus!4v1715980000000!5m2!1sen!2sus'
  }];
  return <div className="bg-white pb-12 sm:pb-24" data-id="element-254">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-20 mb-8 sm:mb-16" data-id="element-255">
        <h1 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4 sm:mb-6 uppercase tracking-tighter" data-id="element-256">
          Our Locations
        </h1>
        <p className="text-base sm:text-lg text-slate-600 max-w-3xl" data-id="element-257">
          Visit us at either of our convenient locations. We provide
          professional pharmaceutical care and clinical services to our local
          communities.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-258">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12" data-id="element-259">
          {locationData.map((loc, idx) => <div key={idx} className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-260">
              <div className="aspect-video w-full" data-id="element-261">
                <iframe src={loc.mapUrl} width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title={loc.name} className="grayscale hover:grayscale-0 transition-all duration-500" data-id="element-262"></iframe>
              </div>
              <div className="p-6 sm:p-8" data-id="element-263">
                <h2 className="text-xl sm:text-2xl font-black text-slate-900 mb-6 uppercase tracking-tight" data-id="element-264">
                  {loc.name}
                </h2>

                <div className="space-y-6 mb-8" data-id="element-265">
                  <div className="flex items-start gap-4" data-id="element-266">
                    <div className="w-10 h-10 bg-clinical-blue/5 rounded-full flex items-center justify-center text-clinical-blue flex-shrink-0" data-id="element-267">
                      <MapPinIcon className="w-5 h-5" data-id="element-268" />
                    </div>
                    <div data-id="element-269">
                      <p className="text-sm font-bold text-slate-900 uppercase tracking-wide mb-1" data-id="element-270">
                        Address
                      </p>
                      <p className="text-slate-600 text-sm leading-relaxed" data-id="element-271">
                        {loc.address}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-272">
                    <div className="w-10 h-10 bg-clinical-blue/5 rounded-full flex items-center justify-center text-clinical-blue flex-shrink-0" data-id="element-273">
                      <PhoneIcon className="w-5 h-5" data-id="element-274" />
                    </div>
                    <div data-id="element-275">
                      <p className="text-sm font-bold text-slate-900 uppercase tracking-wide mb-1" data-id="element-276">
                        Phone
                      </p>
                      <p className="text-slate-600 text-sm" data-id="element-277">{loc.phone}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-278">
                    <div className="w-10 h-10 bg-clinical-blue/5 rounded-full flex items-center justify-center text-clinical-blue flex-shrink-0" data-id="element-279">
                      <ClockIcon className="w-5 h-5" data-id="element-280" />
                    </div>
                    <div className="flex-grow" data-id="element-281">
                      <p className="text-sm font-bold text-slate-900 uppercase tracking-wide mb-1" data-id="element-282">
                        Business Hours
                      </p>
                      <div className="space-y-1" data-id="element-283">
                        {loc.hours.map((h, i) => <div key={i} className="flex justify-between text-sm text-slate-600" data-id="element-284">
                            <span data-id="element-285">{h.days}</span>
                            <span className="font-medium" data-id="element-286">{h.time}</span>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4" data-id="element-287">
                  <button className="flex-grow bg-clinical-blue text-white font-bold py-3 sm:py-4 rounded-xl hover:bg-blue-700 transition-colors uppercase tracking-wider text-xs flex items-center justify-center gap-2" data-id="element-288">
                    Get Directions <ExternalLinkIcon className="w-4 h-4" data-id="element-289" />
                  </button>
                  <button className="px-6 border-2 border-clinical-blue text-clinical-blue font-bold py-3 sm:py-4 rounded-xl hover:bg-clinical-blue hover:text-white transition-all uppercase tracking-wider text-xs" data-id="element-290">
                    Call Store
                  </button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}